/** A run/job row that is still queued or executing — lists poll while any is. */
export function isRunActive(status: string): boolean {
  return status === 'queued' || status === 'running';
}
